import { Box, Typography } from '@mui/material';

import React from 'react'

export const InformationBox = () => {
    return (
      <Box sx={{ boxShadow: 3, border: '1px solid #ccc', p: 2, my: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, color: 'red', fontWeight: 'bold' }}>
        Important Note
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, pb: 2, borderBottom: '1px solid #ccc' }}>
        <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: 'white', border: '1px solid #ccc', mr: 1 }} />
        <Typography variant="body1" sx={{ color: 'black' }}>
        <strong>White code</strong>, in case test has referred facility, represents test not viewed.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, pb: 2, borderBottom: '1px solid #ccc' }}>
        <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: '#B2FF66', mr: 1 }} />
        <Typography variant="body1" sx={{ color: 'black' }}>
        <strong>Green Code</strong> represents test accepted.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: '#FF6666', mr: 1 }} />
        <Typography variant="body1" sx={{ color: 'black' }}>
        <strong>Red Code</strong> represents test rejected.
        </Typography>
      </Box>
    </Box>
    );
  };

export default InformationBox